// extracted by mini-css-extract-plugin
export default {"like":"index_like_srugl","likeCount":"index_likeCount_ieW7u","likeIcon":"index_likeIcon_l0UsO","liked":"index_liked_e-ETc"};